var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTasksUpdates = function SvgTasksUpdates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    fill: "#F2E4FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 8.2002C17.2683 8.2002 13.5315 8.2002 13.2999 8.2002C12.8031 8.2002 12.3999 8.6034 12.3999 9.1002C12.3999 9.597 12.8031 10.0002 13.2999 10.0002C13.5315 10.0002 17.2683 10.0002 17.4999 10.0002C17.9967 10.0002 18.3999 9.597 18.3999 9.1002C18.3999 8.6034 17.9967 8.2002 17.4999 8.2002Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 12.3994C17.2683 12.3994 13.5315 12.3994 13.2999 12.3994C12.8031 12.3994 12.3999 12.8026 12.3999 13.2994C12.3999 13.7962 12.8031 14.1994 13.2999 14.1994C13.5315 14.1994 17.2683 14.1994 17.4999 14.1994C17.9967 14.1994 18.3999 13.7962 18.3999 13.2994C18.3999 12.8026 17.9967 12.3994 17.4999 12.3994Z",
    fill: "#5A6367"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 16.5996C17.2683 16.5996 13.5315 16.5996 13.2999 16.5996C12.8031 16.5996 12.3999 17.0028 12.3999 17.4996C12.3999 17.9964 12.8031 18.3996 13.2999 18.3996C13.5315 18.3996 17.2683 18.3996 17.4999 18.3996C17.9967 18.3996 18.3999 17.9964 18.3999 17.4996C18.3999 17.0028 17.9967 16.5996 17.4999 16.5996Z",
    fill: "#5A6367"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39961 14.7998H8.79961C8.13661 14.7998 7.59961 14.2628 7.59961 13.5998V12.9998C7.59961 12.3368 8.13661 11.7998 8.79961 11.7998H9.39961C10.0626 11.7998 10.5996 12.3368 10.5996 12.9998V13.5998C10.5996 14.2628 10.0626 14.7998 9.39961 14.7998Z",
    fill: "#5A6367"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39961 10.5996H8.79961C8.13661 10.5996 7.59961 10.0626 7.59961 9.39961V8.79961C7.59961 8.13661 8.13661 7.59961 8.79961 7.59961H9.39961C10.0626 7.59961 10.5996 8.13661 10.5996 8.79961V9.39961C10.5996 10.0626 10.0626 10.5996 9.39961 10.5996Z",
    fill: "#5A6367"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39961 19H8.79961C8.13661 19 7.59961 18.463 7.59961 17.8V17.2C7.59961 16.537 8.13661 16 8.79961 16H9.39961C10.0626 16 10.5996 16.537 10.5996 17.2V17.8C10.5996 18.463 10.0626 19 9.39961 19Z",
    fill: "#5A6367"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTasksUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tasks-updates.8c4afe63eda92a558ebff933e2ac976c.svg";